var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'display-container': _vm.enabled, relative: _vm.relative },style:({
		'justify-content': _vm.horizontal,
		'align-items': _vm.vertical,
		'flex-direction': _vm.direction
	})},[(!_vm.multipleBlocks)?_c('div',{staticClass:"display"},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }